import styled from '@emotion/styled/macro'

export const WrapperItems = styled.div`
  margin-top: 15px;
  margin-bottom: 60px;
`
